import { useCallback } from 'react';
import type { NoteTarget } from '@shared/flow/notes';
import { ANALYTICS_EVENTS, type NotesOpenedProps } from '@shared/analytics/events';
import { useSegmentTrack } from '../../../../hooks/useSegmentTrack';
import { useEnrollQueue } from '../../EnrollQueue/EnrollQueueContext';
import { useFlowNotesStore } from './flow-notes-store';

/** Where an open came from; reported on `Notes Opened`. */
export type OpenNotesEntryPoint = NotesOpenedProps['entry_point'];

export interface OpenNotesOptions {
  prefill?: string;
  filter?: 'all';
  entryPoint: OpenNotesEntryPoint;
}

/**
 * Opens the rail on the Notes tab and points the Notes store at `target`
 * (the `openCustomInvite` pattern plus `openTarget`). Use this rather than
 * reaching into the dock's open state from outside the context.
 */
export function useOpenNotes(): (target: NoteTarget, opts: OpenNotesOptions) => void {
  const { openNotes } = useEnrollQueue();
  const track = useSegmentTrack();
  return useCallback(
    (target, opts) => {
      track(ANALYTICS_EVENTS.NOTES_OPENED, { record_kind: target.kind, entry_point: opts.entryPoint } satisfies Pick<NotesOpenedProps, 'record_kind' | 'entry_point'>);
      openNotes();
      useFlowNotesStore.getState().openTarget(target, { prefill: opts?.prefill, filter: opts?.filter });
    },
    [openNotes, track],
  );
}
